import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IAgGridUserPreferencesState,
  PreferencesState,
} from "./preferencesTypes";

const initialState: PreferencesState = {
  theme: "light",
  agGrid: null,
};

const preferencesSlice = createSlice({
  name: "preferences",
  initialState,
  reducers: {
    setTheme: (state, action: PayloadAction<"light" | "dark">) => {
      state.theme = action.payload;
    },
    clearTheme: (state) => {
      state.theme = "light";
    },
    setAgGrid: (state, action: PayloadAction<IAgGridUserPreferencesState>) => {
      state.agGrid = action.payload;
    },
    clearAgGrid: (state) => {
      state.agGrid = null;
    },
    clearPreferences: (state) => {
      state.theme = "light";
      state.agGrid = null;
    },
  },
});

export const {
  setTheme,
  clearTheme,
  setAgGrid,
  clearAgGrid,
  clearPreferences,
} = preferencesSlice.actions;

export default preferencesSlice.reducer;
